import { useEffect } from 'react';
import sharebleLinkSocketService from '../shareableLinkSocketService';
import { ShareableLinkListenEvents } from '../socketEventNames';

export default function useSocketEvent<T>(
  eventType: ShareableLinkListenEvents,
  callback: (eventData: T) => void,
) {
  useEffect(() => {
    sharebleLinkSocketService.addListener(eventType, callback);

    return () => {
      sharebleLinkSocketService.removeListener(eventType, callback);
    };
  }, [eventType, callback]);
}
